export const t = (key) => window.__searchTranslations?.[key] || key
